import React from "react";
import AllRoutes from "./router/router";

const Feature = () => {
  return <AllRoutes />;
};

export default Feature;
